// src/components/CollapsibleSection.tsx
import React from 'react';

interface CollapsibleSectionProps {
  title: string;
  count?: number;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  headerClassName?: string; // ✅ NEW: Custom button styles
  titleClassName?: string;   // ✅ NEW: Custom title styles
}

export function CollapsibleSection({ 
  title, 
  count, 
  isOpen, 
  onToggle, 
  children,
  headerClassName = "w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors",
  titleClassName = "font-semibold text-gray-900",
}: CollapsibleSectionProps) {
  return (
    <div className="space-y-2">
      <button
        onClick={onToggle}
        className={headerClassName}
      >
        <span className={titleClassName}>
          {title}
          {count !== undefined && count > 0 && (
            <span className="ml-2 text-sm font-normal text-gray-600">
              ({count})
            </span>
          )}
        </span>
        <svg
          className={`w-6 h-6 text-gray-600 transition-transform duration-300 ${isOpen ? 'rotate-0' : 'rotate-90'}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="space-y-2">
          {children}
        </div>
      )}
    </div>
  );
}